module.exports = __webpack_public_path__ + "img/qq_logo.01009d18.png";